// Phase-Badges + Quellen-Pills + Betreuer-Pill + Einstufung-Badges (Phase 4)
import React from "react";

export const PHASES = [
  "Identifiziert",
  "Angesprochen",
  "NDA",
  "Datenraum",
  "Verhandlung",
  "Gebot",
  "Abschluss",
  "Abgesagt",
];

export const BETREUER = ["BNP", "Heinrichs", "Gehring", "Kasper", "Adldinger"];

export const EINSTUFUNGEN = ["Heiss", "Reaktivierbar", "Nachrang", "Tot"];

export const INVESTORENTYP_KATEGORIEN = [
  "Institutionell",
  "Family Office",
  "Adel",
  "Retail",
  "Privatperson",
];

// Phase Badge - alle Phasen in Navy mit weißer Schrift (matches Screenshot)
export const PhaseBadge = ({ phase, testid }) => {
  if (!phase) return <span className="text-navy/45 text-xs">—</span>;
  return (
    <span
      data-testid={testid}
      className="pb-badge pb-badge--phase"
    >
      {phase}
    </span>
  );
};

// Einstufungs-Badge (Phase 4): 4 klare Farben
const EINSTUFUNG_CLS = {
  Heiss: "pb-badge--heiss",
  Reaktivierbar: "pb-badge--reaktiv",
  Nachrang: "pb-badge--nachrang",
  Tot: "pb-badge--tot",
};
const EINSTUFUNG_LABELS = {
  Heiss: "Heiß",
  Reaktivierbar: "Reaktivierbar",
  Nachrang: "Nachrang",
  Tot: "Tot",
};
export const EinstufungBadge = ({ einstufung, testid }) => {
  if (!einstufung) return <span className="text-navy/45 text-xs">—</span>;
  const cls = EINSTUFUNG_CLS[einstufung] || "pb-badge--nachrang";
  return (
    <span data-testid={testid} className={`pb-badge ${cls}`}>
      {EINSTUFUNG_LABELS[einstufung] || einstufung}
    </span>
  );
};

// Herkunft-Pill (Phase 4): farbige Pills nach Quelle
export const HerkunftPill = ({ q }) => {
  if (!q) return null;
  let cls = "pb-pill--bnp";
  let label = q;
  if (q.startsWith("Listenchampion")) {
    cls = "pb-pill--listench";
    label = q.replace("Listenchampion-", "LC ");
  } else if (q === "BNP") {
    cls = "pb-pill--bnp";
    label = "BNP";
  } else if (q === "Heinrichs-Recherche") {
    cls = "pb-pill--heinrich";
    label = "Heinrichs-Recherche";
  } else if (q === "Gehring-Recherche") {
    // Eigene Pill-Farbe für Gehring-Quelle (Gold-Akzent), damit visuell
    // klar von Heinrichs-Recherche unterscheidbar.
    cls = "pb-pill--gehring";
    label = "Gehring-Recherche";
  } else if (q.startsWith("Heinrich")) {
    cls = "pb-pill--heinrich";
    label = q;
  } else if (q === "Adldinger" || q === "Eigen") {
    cls = "pb-pill--eigen";
  }
  return <span className={`pb-pill ${cls}`}>{label}</span>;
};

// Tier-Badge (Phase 4.5): T1 = Gold gefüllt, T2 = Navy gefüllt, T3-6 = Outline
export const TierBadge = ({ tier, testid }) => {
  if (tier == null) return <span className="text-navy/40 text-xs font-sans">—</span>;
  const t = Number(tier);
  let cls = "inline-flex items-center justify-center w-7 h-6 text-[10px] font-sans font-bold tabular-nums tracking-tight";
  let style;
  if (t === 1) style = { backgroundColor: "#C4922A", color: "#fff" };
  else if (t === 2) style = { backgroundColor: "#022750", color: "#fff" };
  else style = { backgroundColor: "transparent", color: "#022750", border: "1px solid #022750" };
  return (
    <span data-testid={testid} className={cls} style={style} title={`Tier ${t}`}>
      T{t}
    </span>
  );
};

// Affinitäts-Punkt: grün (hoch) / gelb (mittel) / rot (niedrig)
export const AffinitaetDot = ({ value, label, testid }) => {
  if (!value) return null;
  const colors = { hoch: "#15803D", mittel: "#D97706", niedrig: "#B91C1C" };
  const color = colors[value] || "#9CA3AF";
  return (
    <span
      data-testid={testid}
      title={`${label}: ${value}`}
      className="inline-flex items-center gap-1 text-[10px] font-sans uppercase tracking-widish text-navy/70"
    >
      <span className="inline-block w-2 h-2 rounded-full" style={{ backgroundColor: color }} />
      {label}
    </span>
  );
};

export const QuellenPill = HerkunftPill;

// Betreuer-Pills: BNP = Gold (extern), interne in Navy-Outline
export const BetreuerPill = ({ b, testid }) => {
  if (!b) return <span className="text-navy/45 text-xs">— offen —</span>;
  const isBnp = b === "BNP";
  const isAdldinger = b === "Adldinger";
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center font-sans text-[10px] uppercase tracking-widish px-2 py-0.5"
      style={
        isBnp
          ? { backgroundColor: "#C4922A", color: "#fff" }
          : isAdldinger
          ? { backgroundColor: "#022750", color: "#fff" }
          : { backgroundColor: "#F7F8FA", color: "#022750", border: "1px solid #022750" }
      }
    >
      {b}
    </span>
  );
};
